import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DailySummaryData, TicketSummaryData } from '../../../../../express-tRPC/src/api/lots/types';

@Component({
  selector: 'wps-import-sheet-summary',
  templateUrl: './wps-import-sheet-summary.component.html',
  styleUrl: './wps-import-sheet-summary.component.scss'
})
export class WpsImportSheetSummaryComponent {

  @Input() currentLocation!: string;
  @Input() importFileData!: any;

  @Output() saveDailySummaryData = new EventEmitter<any>();
  @Output() clearSheetSeletion = new EventEmitter<string>();

  importSummaryData() {

    const ticketSummaryTableData: any = this.importFileData?.['tables']?.find((table: any) => table?.title?.trim()?.toLowerCase() == "sales per customer type");

    if (ticketSummaryTableData) {
      let dailySummaryData = structuredClone(ticketSummaryTableData['data']);

      const totalTicketsAmount = dailySummaryData.reduce((sum: number, item: any) => sum + parseFloat(item['Amount'].replace("$", "")), 0);
      const totalTicketsCount = dailySummaryData.reduce((sum: number, item: any) => sum + parseFloat(item['Transactions']), 0);

      /**
       * We want to store only one entry of total daily cashier summary not each record in DRE
       * So we have pushed an object into dailySummaryData
       */
      dailySummaryData = [
        {
          amount: totalTicketsAmount,
          cashier: this.currentLocation,
          shift: 1, //No shift column found in sheet
          tix_collected: totalTicketsCount,
          stations: '' //No stations column found in sheet
        } as DailySummaryData
      ];
      const importSummaryData = {
        dailySummaryData: dailySummaryData,
        ticketSummaryData: [],
        date: this.importFileData['date']
      };

      this.saveDailySummaryData.emit(importSummaryData);
    }

  }

  clearSummaryData() {
    this.clearSheetSeletion.emit(this.importFileData['date']);
  }
}
